export enum RouteNames {
  Home = 'index',
  OrderList = 'orders',
  OrderView = 'orders-id', // link name must have the id name at the end
  OrderTransmissionList = 'orderTransmissionList',
  OrderTransmissionForm = 'orderTransmissionForm',
  Deliveries = 'deliveries',
  History = 'history',
  MyPage = 'myPage',
  Contact = 'contact',
  News = 'news',
  Notifications = 'notifications',
  Collection = 'collection',
  Admin = 'admin',
  Error = 'error',
  XLFlorist = 'xl-florist',
  InternalUserSelect = 'internalUser',
}
